import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NetworkWarningModalComponent } from '../app-common/network-warning-modal/network-warning-modal.component';

@Injectable({
  providedIn: 'root',
})
export class NetworkWarningDialogService {
  private isDialogOpen = false;
  constructor(private dialog: MatDialog) {}

  openNetworkWarningDialog(): void {
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;

    const dialogRef = this.dialog.open(NetworkWarningModalComponent, {
      disableClose: true,
      backdropClass: 'custom-backdrop',
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }
}
